var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "int-page" }, [
    _c("div", { staticClass: "int-header" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.is_pro && _vm.filteredAddons.length
        ? _c("div", { staticClass: "int-header__badges" }, [
            _c("span", { staticClass: "int-badge int-badge--green" }, [
              _c("span", { staticClass: "dashicons dashicons-yes-alt" }),
              _vm._v("\n        " + _vm._s(_vm.activeCount) + " Active\n      ")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "int-badge" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.filteredAddons.length) +
                  " Total\n      "
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "int-toolbar" }, [
      _vm.is_pro
        ? _c("div", { staticClass: "int-toolbar__actions" }, [
            _c(
              "button",
              {
                staticClass: "int-btn int-btn--primary",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleModule("all", "activate")
                  }
                }
              },
              [
                _c("span", { staticClass: "dashicons dashicons-yes-alt" }),
                _vm._v("\n        Activate All\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "int-btn int-btn--ghost",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleModule("all", "deactivate")
                  }
                }
              },
              [
                _c("span", { staticClass: "dashicons dashicons-minus" }),
                _vm._v("\n        Deactivate All\n      ")
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "int-search" }, [
        _c("span", {
          staticClass: "dashicons dashicons-search int-search__icon"
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search"
            }
          ],
          staticClass: "int-search__input",
          attrs: { type: "text", placeholder: "Search integrations..." },
          domProps: { value: _vm.search },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.search
          ? _c(
              "button",
              {
                staticClass: "int-search__clear",
                on: {
                  click: function($event) {
                    _vm.search = ""
                  }
                }
              },
              [_c("span", { staticClass: "dashicons dashicons-no-alt" })]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.filteredAddons.length > 0
      ? _c(
          "div",
          { staticClass: "int-grid" },
          _vm._l(_vm.filteredAddons, function(integration, index) {
            return _c(
              "div",
              {
                key: integration.path || integration.id,
                staticClass: "int-card",
                class: { "int-card--active": integration.enable }
              },
              [
                _c("div", { staticClass: "int-card__body" }, [
                  _c("div", { staticClass: "int-card__thumb" }, [
                    _c("img", {
                      staticClass: "int-card__img",
                      attrs: {
                        src: integration.thumbnail,
                        alt: integration.name
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "int-card__info" }, [
                    _c("h3", { staticClass: "int-card__name" }, [
                      _vm._v(_vm._s(integration.name))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "int-card__desc" }, [
                      _vm._v(_vm._s(integration.description))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "int-card__footer" },
                  [
                    _vm.is_pro
                      ? [
                          _c(
                            "div",
                            { staticClass: "int-card__footer-left" },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.toggleState(
                                      integration,
                                      $event,
                                      index
                                    )
                                  }
                                },
                                model: {
                                  value: integration.enable,
                                  callback: function($$v) {
                                    _vm.$set(integration, "enable", $$v)
                                  },
                                  expression: "integration.enable"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "int-status",
                                  class: integration.enable
                                    ? "int-status--on"
                                    : "int-status--off"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        integration.enable
                                          ? "Active"
                                          : "Inactive"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          integration.enable
                            ? _c(
                                "a",
                                {
                                  staticClass: "int-settings-link",
                                  attrs: {
                                    href:
                                      _vm.admin_url +
                                      "?page=contactum-settings#" +
                                      integration.author_uri,
                                    title: "Configure"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "dashicons dashicons-admin-generic"
                                  }),
                                  _vm._v("\n            Configure\n          ")
                                ]
                              )
                            : _vm._e()
                        ]
                      : [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "int-upgrade-btn",
                              on: { click: _vm.goToPro }
                            },
                            [_vm._v("Upgrade")]
                          )
                        ]
                  ],
                  2
                )
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "int-empty" }, [
          _c("span", {
            staticClass: "dashicons dashicons-search int-empty__icon"
          }),
          _vm._v(" "),
          _c("p", { staticClass: "int-empty__title" }, [
            _vm._v("No integrations found")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "int-empty__sub" }, [
            _vm._v("Try a different search term.")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "int-btn int-btn--ghost",
              on: {
                click: function($event) {
                  _vm.search = ""
                }
              }
            },
            [_vm._v("Clear Search")]
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "int-header__left" }, [
      _c("div", { staticClass: "int-header__icon" }, [
        _c("span", { staticClass: "dashicons dashicons-admin-plugins" })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h2", { staticClass: "int-header__title" }, [
          _vm._v("Integrations")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "int-header__sub" }, [
          _vm._v("Connect your forms with your favourite services")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "int-card__footer-left" }, [
      _c("span", { staticClass: "int-pro-tag" }, [
        _c("span", { staticClass: "dashicons dashicons-lock" }),
        _vm._v("\n              Pro Only\n            ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }